document.addEventListener('DOMContentLoaded', () => {
  // move badges into the active BIG image
  const badges = document.querySelector('.cc-badges');
  if (!badges) return;

  // grab the active media element (Dawn variants supported)
  const getActiveMedia = () =>
    document.querySelector(
      '.product__media-item.is-active .media, ' +
      '.product__media-item--full.is-active .media, ' +
      '.product__media-item .media'
    );

  function placeBadges() {
    const media = getActiveMedia();
    if (!media) return;
    if (!media.contains(badges)) {
      if (!media.style.position) media.style.position = 'relative'; // ensure anchor
      media.appendChild(badges);
    }
  }

  placeBadges();

  // re-place when slide/variant changes
  const gallery = document.querySelector('.product__media-list, media-gallery, .media-gallery');
  if (gallery) {
    new MutationObserver(placeBadges).observe(gallery, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('media-gallery:change', placeBadges);
  document.addEventListener('variant:change', placeBadges);
});